import React from 'react'
import { useTranslation } from 'react-i18next';
import Images from '../../assets/images';
import './Verticals.css';
import { Box, Grid } from '@mui/material';

const Verticals = () => {
  const { t } = useTranslation();

  const verticalTargets = ['school', 'academies', 'club', 'family'];

  const scrollToSection = (target) => {
    const element = document.getElementById(target);

    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <Grid container className='verticals' justifyContent={'center'} id='sections' style={{ scrollMarginTop: 'clamp(96px, 10vw, 212px)' }}>
      <Grid item justifyContent={'center'} alignContent={'center'}>
        <h1 >{t(`verticals.title`)}<span>{t(`verticals.title2`)}</span></h1>
      </Grid>
      <Grid container justifyContent={'space-between'} alignContent={'center'}  >
        {
          t(`verticals.list`).map((item, index) => (
            <Grid key={index} item className='item' alignContent={'end'} justifyContent={'center'}  >
              <img className='image' src={Images.verticals[item.key]} alt={item.label} />
              <Box className='textContainer'>
                <Box flexDirection={'row'} display={'flex'} alignItems={'center'} marginTop={1} marginBottom={0} gap={2}>
                  <h2 className='label'>{item.label}</h2>
                  <button
                    type='button'
                    className='arrowButton'
                    aria-label={`Ir a ${item.label}`}
                    onClick={() => scrollToSection(verticalTargets[index])}
                  >
                    <img className='arrow' src={Images.icons.arrowRight} alt='' />
                  </button>
                </Box>
                <h3 className='description'>{item.description}</h3>
              </Box>
            </Grid>
          ))
        }
      </Grid>
    </Grid>

  )
}

export default Verticals 